<template>
  <Header />

  <div class="section container">
    <div class="loading-spinner" v-if="!requestCompleted" />
    <div class="content" v-if="requestCompleted === true">
      <div class="heading">
        <h1 v-if="order.status === 'draft'">Draft Order</h1>
        <h1 v-if="order.status === 'paid'">Confirmed Order</h1>
        <h1 v-if="order.status === 'expired'">Expired Order</h1>
        <h1 v-if="order.status === 'canceled'">Canceled Order</h1>
      </div>
      <div v-if="order.fulfillments.length > 1">
        <div v-if="order.status === 'paid'" class="tracking">
          <div class="order-fulfillment" v-for="(fulfillment, index) in this.fulfillments" :key="fulfillment.id">
            <div class="tracking__dots" :class="fulfillment.shipment_status">
              <div class="tracking__indicator">
                <span class="circle">
                  <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.388184 6.44364L6.87599 12.6611L18.2296 0.361328" stroke="#181818"/>
                  </svg>
                </span>
                <span class="tracking__status">Placed</span></div>

              <div class="tracking__indicator">
                <span class="circle">
                  <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg" :stroke="fulfillment.shipment_status === STATUS_SHIPPED || fulfillment.shipment_status === STATUS_DELIVERED || (fulfillment.shipment_status == null && fulfillment.tracking_number) ? '#181818': '#C4C4C4'">>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M15.2198 11.3703L14.992 27.5977L27.952 22.1257V6.51506L15.2198 11.3703ZM26.7061 5.9199L14.5863 1.5837L2.31974 6.04676L14.7353 10.4848L26.7061 5.9199ZM0.844428 5.51941L0.612954 5.60363L0.497575 5.64561C0.372775 5.67681 0.279175 5.80161 0.279175 5.92641V22.5248C0.279175 22.6496 0.341575 22.7744 0.466375 22.8056L13.9781 28.5835L14.4752 28.796C14.4752 28.796 14.5688 28.8272 14.6 28.8272C14.63 28.8272 14.6888 28.8272 14.7211 28.7995L14.7248 28.796L14.9767 28.6896L28.7648 22.868C28.8896 22.8056 28.952 22.712 28.952 22.5872V5.86401C28.952 5.73921 28.8584 5.61441 28.7336 5.58321L14.6936 0.560006C14.6312 0.528806 14.5376 0.528806 14.4752 0.560006L0.844428 5.51941ZM1.27918 22.0656L13.9933 27.5023L14.2198 11.3625L1.27918 6.73678V22.0656Z"
                          fill="black"/>
                  </svg>
                </span>
                <span class="tracking__status">Shipped</span>
              </div>

              <div class="tracking__indicator">
                <span class="circle">
                  <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg" :stroke="fulfillment.shipment_status === STATUS_DELIVERED ? '#181818': '#C4C4C4'">
                    <circle cx="4.96627" cy="16.9511" r="1.62398"/>
                    <circle cx="17.2382" cy="16.9511" r="1.62398"/>
                    <path d="M3.31427 16.4792H2.13428V3.73535H14.4062V16.4792H6.85424"/>
                    <path d="M14.6421 6.56738H18.1821L19.834 10.3434L21.958 11.5233V16.2433H18.8901M14.6421 16.2433H15.3501"/>
                  </svg>
                </span>
                <span class="tracking__status">Delivered</span></div>
            </div>
            <div class="tracking__details">
              <div class="tracking__number" v-if="fulfillment.tracking_number.length">
                <span>Tracking Number:</span><a :href="fulfillment.tracking_url" target="_blank">{{fulfillment.tracking_number}}</a>
              </div>
              <div class="tracking__info">
                <div class="info__status">
                  <span class="info__header">tracking information</span>
                  <span class="info__tracking" v-if="fulfillment.shipment_status === STATUS_PLACED">Order Placed</span>
                  <span class="info__tracking" v-if="fulfillment.shipment_status === STATUS_SHIPPED">{{(fulfillment.tracking_number.length && fulfillment.shipment_status) || 'In Transit' }}</span>
                  <span class="info__tracking" v-if="fulfillment.shipment_status === STATUS_DELIVERED">Order Delivered</span>
                </div>
                <div>
                  {{ ((fulfillment.shipment_status === STATUS_SHIPPED ||  fulfillment.shipment_status === STATUS_DELIVERED) && fulfillment.tracking_number.length) ? helpers.formatDate(order.tracking_details[index].updated_at || order.status_updated_at) : helpers.formatDate(order.status_updated_at) }}
                </div>
              </div>
              <div class="tracking__delivery" v-if="order.trackingStatus !== STATUS_DELIVERED">
                <span>Estimated Delivery</span><span>{{helpers.formatDate(order.estimated_delivery_at)}}</span>
              </div>
              <div class="tracking__delivery" v-if="order.trackingStatus === 'exception'">
                <span>Delivery Exception</span><span>{{helpers.formatDate(order.status_updated_at)}}</span>
              </div>
            </div>
            <div v-if="order.drafted_by && order.created_by == null" class="tracking__seedee">
              <div class="tracking__seedee--details">
                <span class="info__header">Order drafted by</span>
                <span>{{ order.drafted_by }}</span>
              </div>
              <div v-if="order.recreated_order_id" class="tracking__seedee--details tracking__seedee--details--right">
                <span class="info__header info__header--right">Recreated Order</span>
                <a href="#" @click="viewOrderDetails(order.recreated_order_id)" >#{{ order.recreated_order_id }}</a>
              </div>
            </div>
            <table class="table">
              <thead>
                <tr>
                  <th>Order #</th>
                  <th>Shipment</th>
                  <th>Name</th>
                  <th>Order Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td width="85px">{{ order.order_number }}</td>
                  <td width="85px">{{ index + 1 }} of {{  order.fulfillments.length  }}</td>
                  <td><span @click = viewCustomerDetails(order.customer) :class="{'col-name': this.isSeedingCustomer(order.customer)}">{{ order.customer.first_name }} {{ order.customer.last_name }}</span></td>
                  <td><div class="col-date">{{ helpers.formatDate(order.created_at) }}</div></td>
                </tr>
              </tbody>
            </table>
            <div class="order-details">
              <div class="order-details__item" v-for="line_item in fulfillment.line_items" :key="line_item.id">
                <img :src="order.line_items.find((product) => product.name == line_item.name).product_image.src" alt="" />
                <div class="order-details__info">
                  <h4>{{ line_item.title }}</h4>
                  <span>{{ line_item.variant_title }}</span>
                  <span>QTY: {{ line_item.quantity }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="order-shipping__adress__container">
            <h4 class="order-shipping__title">Shipping Address</h4>
            <div class="order-shipping__adr">
              <span>{{ order.shipping_address.first_name }} {{ order.shipping_address.last_name }}</span>
              <span>{{ order.shipping_address.address1 }}</span>
              <span v-if="order.shipping_address.address2 !== ''">{{ order.shipping_address.address2 }}</span>
              <span>{{ order.shipping_address.city }}, {{ order.shipping_address.province }} {{ order.shipping_address.zip }}</span>
              <span>{{ order.shipping_address.country }}</span>
            </div>
          </div>
          </div>
          <div v-if="order.created_by" class="tracking__seedee--bottom">
            <div class="tracking__seedee--created-by">
              <span class="info__header">Order confirmed by</span>
              <span>{{ order.created_by }}</span>
            </div>
            <div class="tracking__seedee--created-by">
              <span class="info__header">Order drafted by</span>
              <span>{{ order.drafted_by }}</span>
            </div>
            <div v-if="order.recreated_order_id" class="tracking__seedee--details">
              <span class="info__header info__header--right">Recreated Order</span>
              <a href="#" @click="viewOrderDetails(order.recreated_order_id)" >#{{ order.recreated_order_id }}</a>
            </div>
          </div>
            <div class="order-shipping" v-if="order.status === 'paid'">
            <div class="buttons" v-if="order.status !== 'paid'">
              <button class="btn btn--primary" v-if="order.status === 'draft'" @click="assignCategoryToOrder">Confirm</button>
              <button class="btn btn--warning" v-if="order.status === 'draft'" @click="cancelOrder">Cancel</button>
              <button class="btn btn--primary" v-if="order.status === 'expired'" @click="recreateOrder">Recreate</button>
            </div>
          </div>
      </div>
      <div v-else>
        <div v-if="order.status === 'paid'" class="tracking">
        <div class="tracking__dots" :class="order.trackingStatus">
          <div class="tracking__indicator">
            <span class="circle">
              <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.388184 6.44364L6.87599 12.6611L18.2296 0.361328" stroke="#181818"/>
              </svg>
            </span>
            <span class="tracking__status">Placed</span></div>

          <div class="tracking__indicator">
            <span class="circle">
              <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg" :stroke="order.trackingStatus === STATUS_SHIPPED || order.trackingStatus === STATUS_DELIVERED ? '#181818': '#C4C4C4'">>
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M15.2198 11.3703L14.992 27.5977L27.952 22.1257V6.51506L15.2198 11.3703ZM26.7061 5.9199L14.5863 1.5837L2.31974 6.04676L14.7353 10.4848L26.7061 5.9199ZM0.844428 5.51941L0.612954 5.60363L0.497575 5.64561C0.372775 5.67681 0.279175 5.80161 0.279175 5.92641V22.5248C0.279175 22.6496 0.341575 22.7744 0.466375 22.8056L13.9781 28.5835L14.4752 28.796C14.4752 28.796 14.5688 28.8272 14.6 28.8272C14.63 28.8272 14.6888 28.8272 14.7211 28.7995L14.7248 28.796L14.9767 28.6896L28.7648 22.868C28.8896 22.8056 28.952 22.712 28.952 22.5872V5.86401C28.952 5.73921 28.8584 5.61441 28.7336 5.58321L14.6936 0.560006C14.6312 0.528806 14.5376 0.528806 14.4752 0.560006L0.844428 5.51941ZM1.27918 22.0656L13.9933 27.5023L14.2198 11.3625L1.27918 6.73678V22.0656Z"
                      fill="black"/>
              </svg>
            </span>
            <span class="tracking__status">Shipped</span>
          </div>

          <div class="tracking__indicator">
            <span class="circle">
              <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg" :stroke="order.trackingStatus === STATUS_DELIVERED ? '#181818': '#C4C4C4'">
                <circle cx="4.96627" cy="16.9511" r="1.62398"/>
                <circle cx="17.2382" cy="16.9511" r="1.62398"/>
                <path d="M3.31427 16.4792H2.13428V3.73535H14.4062V16.4792H6.85424"/>
                <path d="M14.6421 6.56738H18.1821L19.834 10.3434L21.958 11.5233V16.2433H18.8901M14.6421 16.2433H15.3501"/>
              </svg>
            </span>
            <span class="tracking__status">Delivered</span></div>
        </div>

        <div class="tracking__details">
          <div class="tracking__number" v-if="order.tracking_details.length">
            <span>Tracking Number:</span><a :href="order.tracking_details[0].url" target="_blank">{{order.tracking_details[0].tracking_number}}</a>
          </div>
          <div class="tracking__info">
            <div class="info__status">
              <span class="info__header">tracking information</span>
              <span v-if="order.trackingStatus === STATUS_PLACED">Order Placed</span>
              <span v-if="order.trackingStatus === STATUS_SHIPPED">{{(order.tracking_details.length && order.tracking_details[0].status) || 'In Transit' }}</span>
              <span v-if="order.trackingStatus === STATUS_DELIVERED">Order Delivered</span>
            </div>
            <div>
              {{ ((order.trackingStatus === STATUS_SHIPPED ||  order.trackingStatus === STATUS_DELIVERED) && order.tracking_details.length) ? helpers.formatDate(order.tracking_details[0].updated_at || order.status_updated_at) : helpers.formatDate(order.status_updated_at) }}
            </div>
          </div>
          <div class="tracking__delivery" v-if="order.trackingStatus !== STATUS_DELIVERED">
            <span>Estimated Delivery</span><span>{{helpers.formatDate(order.estimated_delivery_at)}}</span>
          </div>
          <div class="tracking__delivery" v-if="order.trackingStatus === 'exception'">
            <span>Delivery Exception</span><span>{{helpers.formatDate(order.status_updated_at)}}</span>
          </div>
        </div>
      </div>
      <div v-if="order.drafted_by && order.created_by == null" class="tracking__seedee">
        <div class="tracking__seedee--details">
          <span class="info__header">Order drafted by</span>
          <span>{{ order.drafted_by }}</span>
        </div>
        <div v-if="order.recreated_order_id" class="tracking__seedee--details tracking__seedee--details--right">
          <span class="info__header info__header--right">Recreated Order</span>
          <a href="#" @click="viewOrderDetails(order.recreated_order_id)" >#{{ order.recreated_order_id }}</a>
        </div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th>Order #</th>
            <th>Name</th>
            <th>Order Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="85px">{{ order.order_number }}</td>
            <td><span @click = viewCustomerDetails(order.customer) :class="{'col-name': this.isSeedingCustomer(order.customer)}">{{ order.customer.first_name }} {{ order.customer.last_name }}</span></td>
            <td><div class="col-date">{{ helpers.formatDate(order.created_at) }}</div></td>
          </tr>
        </tbody>
      </table>
      <div v-if="Object.keys(orderLineItems).length == 1">
        <div class="order-details">
          <div class="order-details__item" v-for="line_item in order.line_items" :key="line_item.id">
            <img :src="line_item.product_image.src" alt="" />
            <div class="order-details__info">
              <h4>{{ line_item.title }}</h4>
              <span>{{ line_item.variant_title }}</span>
              <span>QTY: {{ line_item.quantity }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="order-details" v-for="(orderLineItem, key) in orderLineItems" :key="orderLineItem.id">
          <span class="fulfillment-status">{{ key == 'null' ? 'Unfulfilled' : key.charAt(0).toUpperCase() + key.slice(1) }}</span>
          <div class="order-details__item" v-for="line_item in orderLineItem" :key="line_item.id">
            <img :src="line_item.product_image.src" alt="" />
            <div class="order-details__info">
              <h4>{{ line_item.title }}</h4>
              <span>{{ line_item.variant_title }}</span>
              <span>QTY: {{ line_item.quantity }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="order-shipping" v-if="order.status === 'paid'">
        <h4 class="order-shipping__title">Shipping Address</h4>
        <div class="order-shipping__adr">
          <span>{{ order.shipping_address.first_name }} {{ order.shipping_address.last_name }}</span>
          <span>{{ order.shipping_address.address1 }}</span>
          <span v-if="order.shipping_address.address2 !== ''">{{ order.shipping_address.address2 }}</span>
          <span>{{ order.shipping_address.city }}, {{ order.shipping_address.province }} {{ order.shipping_address.zip }}</span>
          <span>{{ order.shipping_address.country }}</span>
        </div>
      </div>
      </div>
      <div v-if="order.created_by" class="tracking__seedee--bottom">
        <div class="tracking__seedee--created-by">
          <span class="info__header">Order confirmed by</span>
          <span>{{ order.created_by }}</span>
        </div>
        <div class="tracking__seedee--created-by">
          <span class="info__header">Order drafted by</span>
          <span>{{ order.drafted_by }}</span>
        </div>
        <div v-if="order.recreated_order_id" class="tracking__seedee--details">
          <span class="info__header info__header--right">Recreated Order</span>
          <a href="#" @click="viewOrderDetails(order.recreated_order_id)" >#{{ order.recreated_order_id }}</a>
        </div>
      </div>
      <div class="buttons" v-if="order.status !== 'paid'">
        <button class="btn btn--primary" v-if="order.status === 'draft'" @click="assignCategoryToOrder">Confirm</button>
        <button class="btn btn--warning" v-if="order.status === 'draft'" @click="cancelOrder">Cancel</button>
        <button class="btn btn--primary" v-if="order.status === 'expired'" @click="recreateOrder">Recreate</button>
      </div>
    </div>
  </div>

</template>

<script>
import api from '@/api';
import Header from '../components/Header.vue';
const STATUS_DELIVERED = "delivered";
const STATUS_SHIPPED = "shipped";
const STATUS_PLACED = "placed";

export default {
  name: 'Order',
  components: {
    Header
  },
  data() {
    return {
      order: {
        id: this.$route.params.id
      },
      fulfillments: [],
      orderLineItems: [],
      requestCompleted: false,
      STATUS_PLACED, STATUS_DELIVERED, STATUS_SHIPPED
    }
  },
  methods: {
    viewOrderDetails(orderId) {
      this.$router.push(`/order/${orderId}`);
    },
    assignCategoryToOrder() {
      this.$router.push('/assign-category/'+this.order.order_number);
    },
    confirmOrderShippingAddress() {
      this.$router.push('/confirm-order/'+this.order.order_number);
    },
    cancelOrder(e) {
      e.preventDefault()
      api.cancelOrder(this.order.id).then(() => {
        this.$router.push('/cancel-order-success');
      }).catch(() => {
        this.$router.push('/cancel-order-error');
      })
    },
    recreateOrder() {
      console.log('order recreation');
      this.$router.push('/recreate-order/'+this.order.order_number);
    },
    isSeedingCustomer(customer) {
      return customer.tags.split(', ').includes('seeding')
    },
    viewCustomerDetails(customer) {
      if(this.isSeedingCustomer(customer)) {
        this.$router.push(`/customer/${customer.id}`);
      }
    },
  },
  mounted() {
    this.axios({
      method: 'get',
      url: `/v1/orders/numbered/${this.order.id}.json`,
    })
    .then(response => {
      this.order = response.data.record;
      this.fulfillments = response.data.record.fulfillments;
      for (var fulfillment in this.fulfillments) {
        let f = this.fulfillments[fulfillment]
        if (f.shipment_status == null && f.tracking_number) {
          f.shipment_status = 'shipped'
        }
      }
      this.orderLineItems = this.order.line_items.reduce((result, a) => {
        const key = a.fulfillment_status;
        result[key] = result[key] || [];
        result[key].push(a);
        return result;
      }, {});
      this.order.trackingStatus = this.order.status;
      if(this.order.status != 'canceled') {
        this.order.status = 'paid';
      }
      if(this.order.financial_status == 'pending') {
        if(this.order.cancelled_at === null) {
          this.order.status = 'draft'
        } else if(this.order.status == 'canceled') {
          this.order.status = 'canceled'
        } else {
          this.order.status = 'expired'
        }
      }
      this.requestCompleted = true;
    })
   .catch((error) => { console.log(error) });
  }
}
</script>

<style scoped>
.order-fulfillment {
  margin-bottom: 40px;
}
.tracking {
  --grey-out: #C4C4C4;
  --active: #181818;
}

.tracking {
  margin-bottom: 32px;
}

.tracking__dots {
  display: flex;
  justify-content: space-between;
  position: relative;
  padding-bottom: 18px;
}

.order-details {
  margin-bottom: 10px;
}

.tracking__dots:before, .tracking__dots:after {
  position: absolute;
  display: block;
  content: "";
  height: 1px;
  width: calc(50% - 78px);
  top: 20px;
  background-color: var(--active);
}

.tracking__dots:before {
  left: 48px;
}

.tracking__dots:after {
  right: 48px;
  background-color: var(--grey-out);
}

.tracking__dots.delivered:after {
  background-color: var(--active);
}

.tracking__indicator {
  font-size: 13px;
  position: relative;
}

.tracking__status {
  position: absolute;
  left: 0;
  color: var(--active);
}

.tracking__indicator:nth-child(2) .tracking__status {
  left: -6px;
  color: var(--grey-out);
}

.tracking__indicator:last-child .tracking__status {
  right: 0;
  left: auto;
  color: var(--grey-out);
}

.shipped .tracking__indicator:nth-child(2) .tracking__status,
.delivered .tracking__indicator:nth-child(2) .tracking__status,
.delivered .tracking__indicator:last-child .tracking__status {
  color: var(--active);
}

.circle {
  display: block;
  height: 40px;
  width: 40px;
  border: 1px solid var(--grey-out);
  border-radius: 50%;
  margin-bottom: 8px;
  text-align: center;
  line-height: 50px;
}

.tracking__indicator:first-child .circle {
  line-height: 43px;
  border: 2px solid var(--active);
}

.shipped .tracking__indicator:nth-child(2) .circle,
.delivered .tracking__indicator:nth-child(2) .circle,
.delivered .tracking__indicator:last-child .circle {
  border: 2px solid var(--active);
}

.tracking__indicator:nth-child(2) svg {
  width: 19px;
  height: auto;
}

.tracking__details {
  margin-top: 40px;
}

.tracking__info, .tracking__delivery {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tracking__seedee {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 10px;
}

.tracking__seedee--bottom {
  margin-top: 15px;
  display: column
}

.tracking__seedee--details {
  display: flex;
  flex-direction: column;
}

.tracking__seedee--details--right {
  align-items: flex-end;
}

.tracking__seedee--created-by,
.tracking__seedee--drafted-by {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.info__status {
  display: flex;
  flex-direction: column;
}

.info__header {
  text-transform: uppercase;
  font-size: 10px;
  margin-bottom: 2px;
}

.info__tracking {
  text-transform: capitalize;
}

.tracking__info, .tracking__number {
  margin-bottom: 12px;
}

.tracking__number a {
  text-decoration: underline;
  margin-left: 2px;
}

.tracking__delivery:not(:last-child) {
  margin-bottom: 12px;
}

.col-name {
  cursor: pointer;
}

.loading-spinner {
  background: url(../assets/images/loading_spinner.gif) no-repeat center center;
  width: 400px;
  height: 400px;
  margin: auto;
}

.order-shipping__adress__container {
  background: white;
  border: 1px solid #e5e5e5;
}

.fulfillment-status {
  margin-bottom: 10px;
  display: inline-block;
}

</style>
